import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "space-y-4 p-4 sm:p-6 lg:p-8" }
const _hoisted_2 = { class: "flex items-center text-xl font-semibold text-gray-800" }
const _hoisted_3 = { class: "flex space-x-4" }
const _hoisted_4 = { class: "space-y-4" }
const _hoisted_5 = { class: "grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3" }
const _hoisted_6 = { class: "mb-1 font-semibold" }
const _hoisted_7 = { class: "mt-2 flex flex-wrap justify-between" }
const _hoisted_8 = { class: "flex items-center space-x-1 text-xs text-gray-600" }
const _hoisted_9 = {
  key: 0,
  class: "ml-1"
}
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "flex items-center space-x-1 text-xs text-gray-600" }
const _hoisted_12 = { class: "ml-1" }
const _hoisted_13 = { class: "grid grid-cols-1 gap-4 lg:grid-cols-2" }
const _hoisted_14 = { class: "mb-4 text-base font-semibold text-gray-800" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "mb-4 text-base font-semibold text-gray-800" }
const _hoisted_17 = { class: "flex flex-col gap-6 md:flex-row md:items-start" }
const _hoisted_18 = { class: "flex-1" }
const _hoisted_19 = { class: "text-muted-foreground text-xs font-semibold uppercase tracking-wider" }
const _hoisted_20 = { class: "mt-2 text-sm leading-relaxed" }
const _hoisted_21 = { class: "text-center text-xs font-medium text-gray-500" }
const _hoisted_22 = { class: "mt-1 text-center text-2xl font-semibold text-gray-800" }
const _hoisted_23 = { class: "mt-6 rounded-lg border bg-gray-300/40 p-4" }
const _hoisted_24 = { class: "text-xs font-bold uppercase text-gray-600" }
const _hoisted_25 = { class: "mt-2 text-sm leading-relaxed text-gray-600" }
const _hoisted_26 = { class: "mt-4 grid gap-3 md:grid-cols-3" }
const _hoisted_27 = { class: "text-xs uppercase text-gray-500" }
const _hoisted_28 = { class: "mt-1 text-base font-semibold" }
const _hoisted_29 = { class: "mt-1 text-xs text-gray-600" }
const _hoisted_30 = { class: "mt-3 flex flex-wrap gap-1.5" }
const _hoisted_31 = { class: "space-y-4 pt-4" }
const _hoisted_32 = { class: "flex flex-wrap items-center justify-between gap-4" }
const _hoisted_33 = { class: "text-lg font-semibold text-gray-800" }
const _hoisted_34 = {
  role: "list",
  class: "my-2 space-y-2"
}
const _hoisted_35 = {
  key: 0,
  class: "mt-0.5 flex h-48 flex-col flex-wrap items-center justify-center rounded-b bg-gray-200 font-semibold text-gray-600"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UiBackButton = _resolveComponent("UiBackButton")!
  const _component_UiButton = _resolveComponent("UiButton")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_UiPageHeader = _resolveComponent("UiPageHeader")!
  const _component_UiPanel = _resolveComponent("UiPanel")!
  const _component_UiPagination = _resolveComponent("UiPagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_UiPageHeader, null, {
      info: _withCtx(() => [
        _createElementVNode("h1", _hoisted_2, [
          _createVNode($setup["BookOpenIcon"], {
            class: "mr-1 h-6 w-6 text-gray-500",
            "aria-hidden": "true"
          }),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('contact.timeline.section.contact.title')), 1 /* TEXT */)
        ])
      ]),
      actions: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_UiBackButton, { fallbackTo: { name: 'ListContact' } }),
          ($setup.showAskAuraButton)
            ? (_openBlock(), _createBlock($setup["ContactAuraPanel"], { key: 0 }))
            : _createCommentVNode("v-if", true),
          (_ctx.$can($setup.Permission.EDIT_CONTACT))
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 1,
                to: {
                            name: 'EditContactById',
                            params: {
                                id: $setup.route.params.id,
                            },
                        },
                class: "block hover:bg-gray-50"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_UiButton, {
                    variant: "primary",
                    "text-variant": "white"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('core.actions.Edit')), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["to"]))
            : _createCommentVNode("v-if", true)
        ])
      ]),
      _: 1 /* STABLE */
    }),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_UiPanel, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", null, [
              _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.$t('contact.timeline.section.contact.name')), 1 /* TEXT */),
              _createElementVNode("p", null, _toDisplayString($setup.contact?.name), 1 /* TEXT */)
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('contact.timeline.section.contact.company')) + ": ", 1 /* TEXT */),
              ($setup.contact?.contactCompany)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString($setup.contact?.contactCompany), 1 /* TEXT */))
                : (_openBlock(), _createElementBlock("span", _hoisted_10, "-"))
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('contact.timeline.section.contact.ownerUser')) + ": ", 1 /* TEXT */),
              _createElementVNode("div", _hoisted_12, _toDisplayString($setup.contact?.ownerUser.name), 1 /* TEXT */)
            ])
          ])
        ]),
        _: 1 /* STABLE */
      }),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_UiPanel, null, {
          default: _withCtx(() => [
            _createElementVNode("h3", _hoisted_14, _toDisplayString(_ctx.$t('contact.timeline.section.email')), 1 /* TEXT */),
            ($setup.contact?.emails.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("p", null, _toDisplayString(_ctx.$t('contact.errors.noEmails')), 1 /* TEXT */)
                ]))
              : (_openBlock(), _createBlock(_component_UiPanel, {
                  key: 1,
                  class: "flex items-center bg-white"
                }, {
                  default: _withCtx(() => [
                    _createVNode($setup["MailIcon"], {
                      class: "mr-1.5 h-5 w-5 flex-shrink-0 text-gray-400",
                      "aria-hidden": "true"
                    }),
                    _createTextVNode(" " + _toDisplayString($setup.mainEmail?.email), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }))
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_UiPanel, null, {
          default: _withCtx(() => [
            _createElementVNode("h3", _hoisted_16, _toDisplayString(_ctx.$t('contact.timeline.section.phone')), 1 /* TEXT */),
            ($setup.mainPhone)
              ? (_openBlock(), _createBlock(_component_UiPanel, {
                  key: 0,
                  class: "flex items-center bg-white"
                }, {
                  default: _withCtx(() => [
                    _createVNode($setup["PhoneIcon"], {
                      class: "mr-1.5 h-5 w-5 flex-shrink-0 text-gray-400",
                      "aria-hidden": "true"
                    }),
                    _createTextVNode(" " + _toDisplayString($setup.applyPhoneMask($setup.mainPhone?.number)), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true)
          ]),
          _: 1 /* STABLE */
        })
      ])
    ]),
    _createCommentVNode(" Contact Analysis "),
    _createVNode(_component_UiPanel, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_17, [
          _createVNode($setup["ContactHealthScoreChart"], { healthScore: $setup.healthScore }, null, 8 /* PROPS */, ["healthScore"]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("h2", _hoisted_19, _toDisplayString(_ctx.$t('contact.timeline.stats.analysis.title')), 1 /* TEXT */),
            _createElementVNode("p", _hoisted_20, _toDisplayString($setup.healthScoreAnalysis), 1 /* TEXT */)
          ])
        ]),
        ($setup.headerStats.length)
          ? (_openBlock(), _createElementBlock("dl", {
              key: 0,
              class: _normalizeClass(["mt-6 grid grid-cols-2 gap-4", ['sm:grid-cols-' + $setup.headerStats.length]])
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.headerStats, (stat) => {
                return (_openBlock(), _createBlock(_component_UiPanel, {
                  key: stat.name
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("dt", _hoisted_21, _toDisplayString(_ctx.$t('contact.timeline.stats.' + stat.name)), 1 /* TEXT */),
                    _createElementVNode("dd", _hoisted_22, _toDisplayString(stat.value), 1 /* TEXT */)
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1024 /* DYNAMIC_SLOTS */))
              }), 128 /* KEYED_FRAGMENT */))
            ], 2 /* CLASS */))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("h3", _hoisted_24, _toDisplayString(_ctx.$t('contact.timeline.stats.analysis.healthScoreCalculation.title')), 1 /* TEXT */),
          _createElementVNode("p", _hoisted_25, _toDisplayString(_ctx.$t('contact.timeline.stats.analysis.healthScoreCalculation.description')), 1 /* TEXT */),
          _createElementVNode("ul", _hoisted_26, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.factors, (factor) => {
              return (_openBlock(), _createElementBlock("li", {
                key: factor.key,
                class: "bg-card rounded-lg border border-gray-300 bg-white p-4"
              }, [
                _createElementVNode("p", _hoisted_27, _toDisplayString(_ctx.$t(
                                    'contact.timeline.stats.analysis.healthScoreCalculation.factors.' +
                                        factor.key +
                                        '.title',
                                )), 1 /* TEXT */),
                _createElementVNode("p", _hoisted_28, _toDisplayString(factor.value), 1 /* TEXT */),
                _createElementVNode("p", _hoisted_29, [
                  (factor.key === 'predominantSentiment')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(_ctx.$t(
                                        'contact.timeline.stats.analysis.healthScoreCalculation.factors.' +
                                            factor.key +
                                            '.description',
                                        {
                                            count: factor.count,
                                            percentage: factor.percentage,
                                        },
                                    )), 1 /* TEXT */)
                      ], 64 /* STABLE_FRAGMENT */))
                    : (factor.key === 'estimatedSatisfaction')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(_ctx.$t(
                                        'contact.timeline.stats.analysis.healthScoreCalculation.factors.' +
                                            factor.key +
                                            '.description',
                                        {
                                            count: factor.count,
                                        },
                                    )), 1 /* TEXT */)
                        ], 64 /* STABLE_FRAGMENT */))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          _createTextVNode(_toDisplayString(_ctx.$t(
                                        `contact.timeline.stats.analysis.healthScoreCalculation.factors.${factor.key}.${factor.trend}`,
                                    )), 1 /* TEXT */)
                        ], 64 /* STABLE_FRAGMENT */)),
                  _createElementVNode("template", _hoisted_30, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(factor.evidence, (evidence) => {
                      return (_openBlock(), _createBlock(_component_UiButton, {
                        key: evidence.id,
                        class: "text-primary rounded border px-2 py-1 text-[11px] font-medium transition-colors hover:bg-gray-100"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(evidence.label) + " " + _toDisplayString(evidence.satisfaction), 1 /* TEXT */)
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1024 /* DYNAMIC_SLOTS */))
                    }), 128 /* KEYED_FRAGMENT */))
                  ])
                ])
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ])
      ]),
      _: 1 /* STABLE */
    }),
    _createCommentVNode(" Timeline "),
    _createElementVNode("div", _hoisted_31, [
      _createElementVNode("div", _hoisted_32, [
        _createElementVNode("h2", _hoisted_33, _toDisplayString(_ctx.$t('contact.timeline.title')), 1 /* TEXT */),
        _createVNode($setup["ContactTimelineFilters"])
      ]),
      _createElementVNode("ul", _hoisted_34, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.calls, (call) => {
          return (_openBlock(), _createBlock($setup["ContactTimelineCallDetails"], {
            key: call.id,
            call: call
          }, null, 8 /* PROPS */, ["call"]))
        }), 128 /* KEYED_FRAGMENT */)),
        (!$setup.calls.length)
          ? (_openBlock(), _createElementBlock("li", _hoisted_35, _toDisplayString(_ctx.$t('core.messages.noRecordsFound')), 1 /* TEXT */))
          : _createCommentVNode("v-if", true)
      ]),
      ($setup.calls.length)
        ? (_openBlock(), _createBlock(_component_UiPagination, {
            key: 0,
            modelValue: $setup.currentPage,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.currentPage) = $event)),
            count: $setup.count,
            perPage: $setup.perPage
          }, null, 8 /* PROPS */, ["modelValue", "count"]))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}